import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Priority } from '../model/Priority';
import { ScheduleInterviewSerializer } from '../model/serializer/schedule-interview-serializer';

import { environment } from '@environments/environment';
import { ScheduleInterview } from '@app/model/scheduleInterview';

@Injectable({ providedIn: 'root' })
export class ScheduleInterviewService extends ApiService<ScheduleInterview> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'interview',
      new ScheduleInterviewSerializer());
  }
}
